import { InjectionToken } from '@angular/core';

export const SEND_SERVICE = new InjectionToken('SEND_SERVICE');
